import TotalPrice from "./totalPrice";
import File from "./file";

export default class ProductAttributeValue {

    quantity = 0;
    index = 0;
    constructor(data, attribute) {
        Object.assign(this, data.attribute_value);

        this.attributeId = data.product_attribute ? data.product_attribute.attribute.id : null;
        this.quantityMultiplier = data.quantity_multiplier;
        this.minQuantity = data.min_quantity;
        this.maxQuantity = data.max_quantity;
        this.dataPrices = data.prices;

        if (!this.quantityMultiplier && (this.minQuantity || this.maxQuantity)) {
            this.quantity = this.minQuantity ? this.minQuantity : 1;
        }

        if (attribute && attribute.hasPrice()) {
            this.attributePrice = attribute.getDefaultPrice();
        }

        if (this.file) {
            this.file = new File(this.file);
        }

        this.calculatePrice();

    }

    calculatePrice() {
        if (this.dataPrices.price || this.dataPrices.price === 0) {
            this.totalPrice = new TotalPrice(this.dataPrices.currency, this.dataPrices.tax_rate, this.dataPrices.price, this.dataPrices.promo_price);
            this.totalPrice.multiply(this.quantity ? this.quantity : this.quantityMultiplier);
        } else if (this.attributePrice) {
            this.totalPrice = this.attributePrice;
        }

        this.prices = this.dataPrices;
    }

    setPrice() {
        this.calculatePrice();
    }

}
